﻿import { TextButton } from 'components/uikit/buttons/TextButton.tsx';
import {
  SimpleTreeItemWrapper,
  TreeItemComponentProps,
} from 'dnd-kit-sortable-tree';
import { forwardRef } from 'react';
import styles from './SignerListItem.module.scss';
import DragDropDots from 'assets/icons/drag-drop-dots.svg?react';
import RemoveIcon from 'assets/icons/remove.svg?react';
import EditIcon from 'assets/icons/edit.svg?react';
import { SignerDto } from 'services/api/api-client.types.ts';

export type SignerListItemProps = {
  id: number;
  signer: SignerDto;
  onDelete: (id: number) => void;
  onEdit: (id: number) => void;
};

export const SignerListItem = forwardRef<
  HTMLDivElement,
  TreeItemComponentProps<SignerListItemProps>
>((props, ref) => {
  return (
    <SimpleTreeItemWrapper
      {...props}
      showDragHandle={false}
      manualDrag={true}
      ref={ref}
      key={props.item.id}
      className={styles.wrapper}
    >
      <div className={styles.body} data-test-id={'signers-drag-n-drop-option'}>
        <div className={styles.start}>
          <a {...props.handleProps}>
            <DragDropDots />
          </a>
          <span className={styles.name}>
            {props.item.signer.firstName} {props.item.signer.lastName}
          </span>
        </div>
        <div className={styles.end}>
          {props.item.signer.canBeModified && (
            <TextButton
              icon={<EditIcon />}
              className={styles.editButton}
              onClick={() => props.item.onEdit(props.item.signer.id)}
            />
          )}
          <TextButton
            testId={'delete-button'}
            icon={<RemoveIcon />}
            className={styles.deleteButton}
            onClick={() => props.item.onDelete(props.item.signer.id)}
          />
        </div>
      </div>
    </SimpleTreeItemWrapper>
  );
});
